/**
 * GenericPopup Component - Migrated to Junto Frontend
 * 
 * This component now uses the junto-frontend Modal with Sol Room theme
 * to maintain exact visual equivalence while enabling white-label capabilities.
 */

import { Modal } from '../junto-frontend/components/ui';
import { solRoomTheme } from '../junto-frontend/themes/sol-room';

const GenericPopup = ({ 
  isOpen, 
  onClose, 
  children, 
  maxWidth,
  showCloseButton = true,
  fixedHeight = false
}) => {
  return (
    <Modal 
      isOpen={isOpen}
      onClose={onClose}
      maxWidth={maxWidth}
      showCloseButton={showCloseButton}
      fixedHeight={fixedHeight}
      theme={solRoomTheme}
    >
      {children}
    </Modal>
  );
};

export default GenericPopup;